import { useQuery } from '@tanstack/react-query';
import type { ElementHintCategory, ElementHintSourceType } from '@chatsdet/types';
import { API_URL } from '../../../config';
import { toApiError } from '../../../lib/api-error';

export type ElementHint = {
  id: string;
  category: ElementHintCategory;
  element: string;
  frontmatter: string;
  fingerprint: {
    role: string;
    name: string | null;
    ariaLabel: string | null;
    ancestorPath: string | null;
  };
  sourceType: ElementHintSourceType;
  matchCount: number;
  lastMatchedAt: string | null;
  createdAt: string;
};

export function useElementHints(propertyId: string | undefined, canonicalPageId: string | undefined) {
  return useQuery({
    queryKey: ['element-hints', propertyId, canonicalPageId],
    queryFn: async (): Promise<{ hints: ElementHint[] }> => {
      const res = await fetch(
        `${API_URL}/properties/${propertyId}/canonical-pages/${canonicalPageId}/element-hints`,
        { credentials: 'include' }
      );
      if (!res.ok) {
        throw await toApiError(res, 'Failed to load element hints');
      }
      return (await res.json()) as { hints: ElementHint[] };
    },
    enabled: !!propertyId && !!canonicalPageId,
  });
}
